import { TMasterCareerCertification } from "@/api/entities/master-career-certification.entity";
import { setHiddenCareerCertificationApi } from "@/api/services/global/master";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenCareerCertificationModalProps = {
  hiddenCareerCertification?: TMasterCareerCertification;
  setHiddenCareerCertification: Dispatch<SetStateAction<TMasterCareerCertification | undefined>>;
};

export const HiddenCareerCertificationModal: FC<THiddenCareerCertificationModalProps> = ({
  hiddenCareerCertification,
  setHiddenCareerCertification,
}) => {
  const queryClient = useQueryClient();

  const handleSubmit = async () => {
    if (!hiddenCareerCertification) return;
    try {
      await setHiddenCareerCertificationApi(toNumber(hiddenCareerCertification.id), { isHidden: !hiddenCareerCertification.isHidden });
      toast.success(API_SUCCESS_MESSAGE);
      setHiddenCareerCertification(undefined);
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_CAREER_CERTIFICATION] });
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Modal
      title={hiddenCareerCertification?.isHidden ? "有効化の確認" : "無効化の確認"}
      isOpen={!!hiddenCareerCertification}
      onClose={() => setHiddenCareerCertification(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      onOk={() => handleSubmit()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenCareerCertification?.isHidden ? "この行が有効化されますが、よろしいですか。" : "この行が無効化されますが、よろしいですか。"}
      </Typography>
    </Modal>
  );
};
